import { LimitGroup } from '../../types';
import { ProductWithServicesType } from '../../../../../../types/product';
import constants from '../../../../../../ahm-constants';

const {
  PRODUCT: { CHOOSABLE_60_TEETH_EYES_WELLBEING_MUSCLE_BONE },
}: { PRODUCT: { CHOOSABLE_60_TEETH_EYES_WELLBEING_MUSCLE_BONE: string } } = constants;

const getChoosableAllIncludedServices = (products: Record<string, ProductWithServicesType> | undefined): LimitGroup[] =>
  products?.[CHOOSABLE_60_TEETH_EYES_WELLBEING_MUSCLE_BONE]?.extras?.included || [];

export default getChoosableAllIncludedServices;
